module.exports = __webpack_public_path__ + "img/Front Door Left Salone.818777f5.png";